export default __webpack_public_path__ + "static/media/improving_deaplearning.03d601cb.png";